import React, { Component } from 'react'
import { withStyles } from '@material-ui/styles'
import { PostForm } from './../forms'
import { Dashboard } from './../layouts'

const styles = theme => ({
    //
})

class PostNew extends Component {
    constructor(props) {
        super(props)
        
        this.state = {
            title: 'Блог'
        }
    }

    render() {
        const { title } = this.state
        return (
            <Dashboard title={title}>
                <PostForm 
                    path="posts"
                    method="post"
                    message="Амжилттай нэмэгдлээ"
                />
            </Dashboard>
        )
    }
}

export default withStyles(styles)(PostNew)
